import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PoundSterling, Pencil, X } from "lucide-react";
import { PayRatesEditor } from "@/components/PayRatesEditor";

export function PayRatesPanel({ onChanged }) {
  const [staff, setStaff] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/staff").then((r) => setStaff(r.data.filter((s) => s.role === "carer").sort((a, b) => a.name.localeCompare(b.name)))).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-white shadow-sm" data-testid="pay-rates-panel">
      <div className="flex items-center gap-2 border-b border-border px-6 py-4"><PoundSterling size={18} className="text-brand" /><h2 className="font-heading text-lg font-semibold text-ink">Pay rates</h2></div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-ivory text-left text-xs font-semibold uppercase tracking-wider text-ink-muted"><tr><th className="px-6 py-3">Befriender</th><th className="px-6 py-3">Hourly</th><th className="px-6 py-3">Mileage</th><th className="px-6 py-3 text-right">Edit</th></tr></thead>
          <tbody className="divide-y divide-border">
            {staff.map((s) => (
              <tr key={s.id} data-testid={`pay-rate-row-${s.id}`}>
                <td className="px-6 py-3 font-semibold text-ink">{s.name}</td>
                <td className="px-6 py-3 text-ink-soft">£{Number(s.hourly_rate || 0).toFixed(2)}/hr</td>
                <td className="px-6 py-3 text-ink-soft">{(s.is_driver ?? true) ? `£${Number(s.mileage_rate || 0).toFixed(2)}/mile` : "Non-driver"}</td>
                <td className="px-6 py-3 text-right"><button onClick={() => setEdit(s)} data-testid={`edit-pay-rate-${s.id}`} className="inline-flex items-center gap-1 rounded-lg border border-border px-2.5 py-1.5 text-xs font-semibold text-ink hover:bg-secondary"><Pencil size={13} /> Edit</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/40" onClick={() => setEdit(null)} />
          <div className="relative z-10 max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-xl bg-white p-6 shadow-xl" data-testid="pay-rate-modal">
            <div className="mb-4 flex items-center justify-between"><h2 className="font-heading text-xl font-bold text-ink">Pay rates · {edit.name}</h2><button onClick={() => setEdit(null)} data-testid="close-pay-rate-modal"><X size={20} className="text-ink-muted" /></button></div>
            <PayRatesEditor staffId={edit.id} onSaved={() => { load(); onChanged && onChanged(); }} />
          </div>
        </div>
      )}
    </div>
  );
}
